import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, ModuleFE_Dialog, performAction, TS_Input, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import './Editors.scss';
import { ICONS } from '@app/styles';
import { ModuleFE_MeasurementUnit } from '../../../../_entity.js';
export class Dialog_EditMeasurementUnitSynonyms extends ComponentSync {
    // ######################## Static ########################
    static show(measurementUnit, onSave) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_EditMeasurementUnitSynonyms, { measurementUnit: measurementUnit, onSave: onSave }),
            closeOverlayOnClick: () => false
        });
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable ??= new EditableDBItemV3(nextProps.measurementUnit, ModuleFE_MeasurementUnit)
            .setAutoSave(false);
        state.newSynonym ??= '';
        return state;
    }
    // ######################## Logic ########################
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    saveUnit = async () => {
        await performAction(async () => {
            try {
                const savedUnit = await this.state.editable.save();
                this.props.onSave(savedUnit);
                this.closeDialog();
            }
            catch (e) {
                this.logError(e);
            }
        }, { type: 'notification', notificationLabels: 'Saving Unit Synonyms' });
    };
    addSynonym = async (synonym, props) => {
        const trimmed = synonym.trim();
        if (!trimmed || props.existingItems.includes(trimmed))
            return;
        await props.onSelected(trimmed);
        this.setState({ newSynonym: '' });
        this.forceUpdate();
    };
    // ######################## Render ########################
    render() {
        return (_jsxs(LL_V_L, { className: "dialog dialog__edit-measurement-unit-synonyms", children: [this.renderHeader(), this.renderUnits(), this.renderButtons()] }));
    }
    renderUnits() {
        return _jsxs(LL_V_L, { className: 'dialog__main', children: [_jsx("div", { className: 'dialog__field-title', children: "Unit Synonyms" }), _jsx(TS_MultiSelect_V2, { className: 'dialog__synonyms-list', editable: this.state.editable, prop: 'units', itemsDirection: 'vertical', itemRenderer: this.renderSynonymItem, selectionRenderer: this.renderAddSynonymInput })] });
    }
    renderSynonymItem = (item, onDelete) => {
        return _jsxs(LL_H_C, { className: 'dialog__synonym-item', children: [_jsx("span", { className: 'synonym-text', children: item }), _jsx(ICONS.x.component, { className: 'clickable', onClick: onDelete })] });
    };
    renderAddSynonymInput = (props) => {
        return _jsxs(LL_H_C, { className: 'dialog__add-synonym', children: [_jsx(TS_Input, { type: 'text', value: this.state.newSynonym, placeholder: 'Add new synonym...', onChange: newSynonym => this.setState({ newSynonym }), onAccept: () => this.addSynonym(this.state.newSynonym, props) }), _jsx(Button, { variant: 'tertiary', onClick: () => this.addSynonym(this.state.newSynonym, props), children: _jsx(ICONS.advisor_avn_add.component, {}) })] });
    };
    renderHeader() {
        return _jsxs(LL_H_C, { className: "dialog__header", children: [_jsxs("span", { className: "title-text", children: ["Edit Unit Synonyms - ", this.props.measurementUnit.unitAsString] }), _jsx(ICONS.x.component, { className: "exit_icon", onClick: this.closeDialog })] });
    }
    renderButtons() {
        return _jsxs(LL_H_C, { className: "dialog__buttons", children: [_jsx(Button, { variant: 'secondary', onClick: this.closeDialog, children: "Cancel" }), _jsx(Button, { variant: 'primary', onClick: this.saveUnit, className: 'desired-action-button', children: "Save" })] });
    }
}
//# sourceMappingURL=Dialog_EditMeasurementUnitSynonyms.js.map